import { useEffect, useState } from "react";

const AnimatedSaltLogo = ({
	height = 50,
	width = 92,
}: {
	height?: number;
	width?: number;
}) => {
	const [show, setShow] = useState(false);

	useEffect(() => {
		setShow(true);
	}, []);

	return (
		<>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				xmlSpace="preserve"
				style={{
					fillRule: "evenodd",
					clipRule: "evenodd",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeMiterlimit: 1.5,
				}}
				width={width}
				height={height}
				viewBox="0 0 943 507"
				className={show ? "active" : ""}
			>
				<path
					d="M675.089-.004v506.64"
					style={{ fill: "none", stroke: "#000", strokeWidth: "20px" }}
					transform="translate(1.494 3.534) scale(.98677)"
					className="svg-elem-1"
				/>
				<path
					d="M5519.85 2189.38h-6.88c-72.17 0-110.38-31.32-111.05-86.31v-323.24"
					style={{
						fill: "none",
						fillRule: "nonzero",
						stroke: "#000",
						strokeWidth: "20px",
						strokeMiterlimit: 2,
					}}
					transform="translate(-4515.231 -1656.953) scale(.98677)"
					className="svg-elem-2"
				/>
				<path
					d="M729.489 154.395h192.15"
					style={{ fill: "none", stroke: "#000", strokeWidth: "20px" }}
					transform="translate(22.164 25.953) scale(.98677)"
					className="svg-elem-3"
				/>
				<path
					d="M4572.7 2120.33c0 47.67 55.79 87.9 131.77 87.9 75.99 0 131.78-40.23 131.78-87.9.38-51.01-67.43-71.47-130.62-91.89h-.1c-59.68-19.16-119.95-40.09-120.3-88.88 0-47.68 51.63-87.91 119.26-87.91 67.62 0 119.25 40.22 119.26 87.9"
					style={{
						fill: "none",
						fillRule: "nonzero",
						stroke: "#000",
						strokeWidth: "20px",
						strokeMiterlimit: 2,
					}}
					transform="translate(-4145.491 -1503.952) scale(.90906)"
					className="svg-elem-4"
				/>
				<path
					d="M1013.93 825.183 898.14 1027.81l1.447 73.03 38.947 77.37 99.996 45.79 81.58-37.37 31.19-82.82.92-69.29-138.29-209.337Z"
					style={{ fill: "none", stroke: "#000", strokeWidth: "20px" }}
					transform="translate(-584.67 -745.81) scale(1.02066)"
					className="svg-elem-5"
				/>
				<path
					d="m938.534 1178.21 94.876-51.26 5.12 97.05m-24.6-398.817-69.607 225.127-44.736 50.53m114.343-275.657 96.71 228.287 40.66 50.34"
					style={{ fill: "none", stroke: "#000", strokeWidth: "20px" }}
					transform="translate(-584.67 -745.81) scale(1.02066)"
					className="svg-elem-6"
				/>
				<path
					d="m944.323 1050.31 89.087 76.64 77.23-73.48"
					style={{ fill: "none", stroke: "#000", strokeWidth: "20px" }}
					transform="translate(-584.67 -745.81) scale(1.02066)"
					className="svg-elem-7"
				/>
			</svg>
			<style jsx>{`
				svg .svg-elem-1 {
					stroke-dashoffset: 508.6400146484375px;
					stroke-dasharray: 508.6400146484375px;
					-webkit-transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
					transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s;
				}

				svg.active .svg-elem-1 {
					stroke-dashoffset: 0;
				}

				svg .svg-elem-2 {
					stroke-dashoffset: 491.51861572265625px;
					stroke-dasharray: 491.51861572265625px;
					-webkit-transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.15s;
					transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.15s;
				}

				svg.active .svg-elem-2 {
					stroke-dashoffset: 0;
				}

				svg .svg-elem-3 {
					stroke-dashoffset: 194.1500244140625px;
					stroke-dasharray: 194.1500244140625px;
					-webkit-transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.3s;
					transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.3s;
				}

				svg.active .svg-elem-3 {
					stroke-dashoffset: 0;
				}

				svg .svg-elem-4 {
					stroke-dashoffset: 1008.7610473632812px;
					stroke-dasharray: 1008.7610473632812px;
					-webkit-transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.44999999999999996s;
					transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.44999999999999996s;
				}

				svg.active .svg-elem-4 {
					stroke-dashoffset: 0;
				}

				svg .svg-elem-5 {
					stroke-dashoffset: 1003.440185546875px;
					stroke-dasharray: 1003.440185546875px;
					-webkit-transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.6s;
					transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.6s;
				}

				svg.active .svg-elem-5 {
					stroke-dashoffset: 0;
				}

				svg .svg-elem-6 {
					stroke-dashoffset: 822.7897338867188px;
					stroke-dasharray: 822.7897338867188px;
					-webkit-transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.75s;
					transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.75s;
				}

				svg.active .svg-elem-6 {
					stroke-dashoffset: 0;
				}

				svg .svg-elem-7 {
					stroke-dashoffset: 226.1177978515625px;
					stroke-dasharray: 226.1177978515625px;
					-webkit-transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.8999999999999999s;
					transition: stroke-dashoffset 1s
						cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.8999999999999999s;
				}

				svg.active .svg-elem-7 {
					stroke-dashoffset: 0;
				}
			`}</style>
		</>
	);
};

export default AnimatedSaltLogo;
